module.exports = __webpack_public_path__ + "assets/img/6.603f8050.png";